import { gql } from '@apollo/client';
import { useMutation } from '@tbitop/api';
import { useGraphQLErrorHandler } from '@tbitop/error-handling';
import { useCallback } from 'react';
import type { AufgabeErstellenMutation, AufgabeErstellenMutationVariables } from './__generated__/AufgabeErstellenMutation';

export type { AufgabeErstellenMutationVariables as AufgabeErstellenVariables };

export const useAufgabeErstellenMutation = () => {
  const { handleWithErrorNotification } = useGraphQLErrorHandler();
  const [executeMutation, { loading, error }] = useMutation<AufgabeErstellenMutation, AufgabeErstellenMutationVariables>(gql`
    mutation AufgabeErstellen(
      $objektId: UUID!,
      $titel: String!,
      $beschreibung: String!,
      $kategorie: String!,
      $typ: String!,
      $faelligkeit: DateTime,
      $bearbeiter: UUID
    ) {
      aufgabeErstellen(
        objektId: $objektId,
        titel: $titel,
        beschreibung: $beschreibung,
        kategorie: $kategorie,
        typ: $typ,
        faelligkeit: $faelligkeit,
        bearbeiter: $bearbeiter
      ) {
        id
      }
    }
  `, {
    onError: handleWithErrorNotification('Das Erstellen der individuellen Aufgabe ist fehlgeschlagen.'),
    update(cache) {
      cache.evict({ id: 'ROOT_QUERY', fieldName: 'objekteSeitenweise' });
      cache.evict({ id: 'ROOT_QUERY', fieldName: 'offeneAufgabenStatistik' });
    },
  });

  return {
    execute: useCallback((variables: AufgabeErstellenMutationVariables) => executeMutation({ variables }), [executeMutation]),
    loading,
    error,
  };
};
